"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _stencilReactInputMask = _interopRequireWildcard(require("@amzn/stencil-react-input-mask"));

var _utils = require("../../../utils");

var _ = require("../");

var _constants = require("./constants");

var _core = require("@emotion/core");

var _excluded = ["mask", "maskPlaceholder", "onChange", "shouldAlwaysShowMask", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var MaskedInputWithoutDocs = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var mask = _ref.mask,
      _ref$maskPlaceholder = _ref.maskPlaceholder,
      maskPlaceholder = _ref$maskPlaceholder === void 0 ? _constants.DEFAULT_MASK_PLACEHOLDER : _ref$maskPlaceholder,
      onChange = _ref.onChange,
      _ref$shouldAlwaysShow = _ref.shouldAlwaysShowMask,
      shouldAlwaysShowMask = _ref$shouldAlwaysShow === void 0 ? false : _ref$shouldAlwaysShow,
      value = _ref.value,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (forwardedProps.disabled) {
    return (0, _core.jsx)(_.Input, (0, _extends2.default)({}, forwardedProps, {
      ref: ref,
      value: value
    }));
  }

  var inputProps = (0, _utils.omit)(forwardedProps, _stencilReactInputMask.inputMaskControlledProps);
  var maskProps = (0, _utils.pick)(forwardedProps, _stencilReactInputMask.inputMaskControlledProps);
  var maskUtils = new _stencilReactInputMask.MaskUtils({
    mask: mask,
    maskPlaceholder: maskPlaceholder
  });

  var handleOnChange = function handleOnChange(e) {
    var targetValue = e.target.value;

    if (onChange) {
      onChange(e, maskUtils.formatValue(targetValue), targetValue.replace(/[^a-zA-Z\d\u00C0-\u00FF]+/g, ''));
    }
  };

  return (0, _core.jsx)(_stencilReactInputMask.default, (0, _extends2.default)({}, maskProps, {
    alwaysShowMask: shouldAlwaysShowMask,
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    onChange: handleOnChange,
    value: value
  }), (0, _core.jsx)(_.Input, (0, _extends2.default)({}, inputProps, {
    ref: ref
  })));
});
var MaskedInputWithDocs = (0, _stencilReactDesc.describe)(MaskedInputWithoutDocs).description('Input element that automatically formats text according to a mask.');
MaskedInputWithDocs.propTypes = _objectSpread(_objectSpread({}, _.Input.describedPropTypes), {}, {
  mask: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.instanceOf(RegExp)]))]).description("Mask the input's value in order to force it to conform to a particular format or template. More complex masks can be defined as an array of regular expressions and constant characters."),
  maskPlaceholder: _stencilReactDesc.PropTypes.string.description('Displays placeholder text in the input field behind the mask characters. Default placeholder is the figure space character.'),
  onChange: _stencilReactDesc.PropTypes.func.description('Callback function that will be called when the input is changed. It passes both the mask formatted string, and the user input.').format('(e: React.ChangeEvent<HTMLInputElement>, formattedValue: string, unformattedValue: string) => void'),
  shouldAlwaysShowMask: _stencilReactDesc.PropTypes.bool.description('Specifies if the mask should be shown instead of placeholder.')
});
var MaskedInput = (0, _utils.withTestAttributes)({
  component: 'StencilMaskedInput'
})(MaskedInputWithDocs);
MaskedInput.displayName = 'MaskedInput';
var _default = MaskedInput;
exports.default = _default;